const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_LOGIN': {
      return {
        ...state,
        login: action.value,
      };
    }
    case 'SET_DATALOGIN': {
      return {
        ...state,
        dataLogin: action.value,
      };
    }
    default:
      return state;
  }
};

export default reducer;
